const baseColor = {
  black: "#000",
  white: "#FFFFFF",
  primaryColor: "#0c2340", // buttonBG, heading 
  lightPrimaryColor: "#001c3d", //for footer gradient
  darkGrey: "#425466", // label color
  lightGrey: "#EDF2F7", //input  background
  webBackground: "",
  headerBackground: "",
  footerBackground: "",
  //   lightRed: "#FF1313",
  //   darkPink: "#ff1313",
  //   pink: "#fe4e37",
  //   Blue: "#2c234d",
  //   DarkGrey: "#212025",
  //   lightGrey: "#717b9b",
  //   lightBackground: "#f7fdff",
};

export default baseColor;
